function Entry({date, message}) {
    return (
        <p className="news_entry">
            <strong>{date}</strong> | <span dangerouslySetInnerHTML={{ __html: message }} />
        </p>
    );
}


function News() {
  return (
    <article id="news" className="wrapper style2">
      <div className="container">
        <header>
          <h2>News</h2>
        </header>
        <div className="align_left news_entry_container">
          <Entry
            date="September 2026"
            message='Our paper "A Framework for Generating Valid Context-Specific Benchmarks through Expert Guidance" has been accepted to EMNLP 2026 Findings. I am super proud of this work and have so many new projects stemming from this one. Ask me about them in Budapest next month!'
          />
          <Entry
            date="August 2026"
            message='I just wrapped up a wonderful internship with the Sociotechnical Alignment Center (STAC) at Microsoft Research! Our in-progress work "An Empirical Investigation of Systematization Forms in GenAI Evaluation" got accepted to Text as Data (TADA) 2026. Catch our poster in Berkeley, CA this October!'
          />
          <Entry
            date="January 2026"
            message='Our paper "Doubly-Robust LLM-as-a-Judge: Externally Valid Estimation with Imperfect Personas" has been accepted to ICLR 2026!'
          />
          <Entry
            date="August 2025"
            message='Our paper "Persona-Augmented Benchmarking: Evaluating LLMs Across Diverse Writing Styles" has been accepted to EMNLP 2025 Main Conference. I am very excited to present in Suzhou, China!'
          />
          <Entry
            date="August 2025"
            message='The first paper of my Ph.D., "Toward Valid Measurement Of (Un)fairness For Generative AI: A Proposal For Systematization Through The Lens Of Fair Equality of Chances", has been accepted to AIES 2025. See you in Madrid!'
          />
          <Entry
            date="August 2024"
            message="I started my Ph.D. at Carnegie Mellon University!"
          />
          <Entry
            date="June 2024"
            message="I graduated from Oregon State University with dual honors Bachelor of Science degrees in Computer Science and Mathematics!"
          />
          <Entry
            date="June 2024"
            message='Our paper "A structured regression approach for evaluating model performance across intersectional subgroups" will be presented at FAccT 2024 in Rio De Janeiro, Brazil!'
          />
          <Entry
            date="May 2024"
            message='Successfully defended my honors thesis titled "A Deeper Dive into the Subset Scan Statistic for Open Set Recognition".'
          />
          <Entry
            date="May 2024"
            message="Interning at NVIDIA in Santa Clara, CA for the summer! I'll be working on reducing bias and increasing transparency in computer vision models for the trustworthy AI initiative."
          />
          <Entry
            date="June 2023"
            message="Interning at Microsoft Research New York this summer with Drs. Alexandra Chouldechova and Miroslav Dudik in the FATE group!"
          />
          <Entry
            date="March 2023"
            message='I am honored to be named a <a href="https://goldwaterscholarship.gov/2023-scholars/">2023 Barry Goldwater Scholar</a>!'
          />
          <Entry
            date="May 2022"
            message="Had a blast at MSR and ICSE in Pittsburgh, PA! It was amazing presenting my work several times at my first conference(s) and winning first place in the undergraduate student research competition!"
          />
          <Entry
            date="May 2021"
            message="I'll be in Pittsburgh, PA this summer for an REU in software engineering (REUSE) at Carnegie Mellon University working with Professors Christian Kastner and Bogdan Vasilescu!"
          />
        </div>
      </div>
    </article>
  );
}

export default News;
